module.exports = __webpack_public_path__ + "images/carlos-veiga.8c3dace8921b6029cec3edf85b5468e3.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/carlos-veiga.jpeg
// module id = 1026
// module chunks = 0